/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {ClaimsApi} from '../../../api/ms-claims/claims.api';
import {ClaimDetailModel} from '../../../api/ms-claims/contracts/claim-detail.model';
import {AvailableActions} from '../../../api/ms-claims/contracts/available-actions.enum';
import {ConfirmModalComponent} from '../../../shared/confirm-modal/deprecated-modals/confirm-modal.component';
import {AlertNotificationSeverity} from '../../../alert-notification-severity.model';
import {ConfirmModal} from '../../../shared/confirm-modal/deprecated-modals/confirm-modal.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Injectable({
    providedIn: 'root'
})
export class EditGuard  {

    constructor(
            private claimApi: ClaimsApi,
            private router: Router,
            private modalService: NgbModal
    ) {
    }

    canActivate(
            next: ActivatedRouteSnapshot,
            state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const claimNumber: string = state.url.split('/')[2];
        const canActivate = new Subject<boolean>();
        this.claimApi.getClaimDetail(claimNumber).subscribe((claim: ClaimDetailModel) => {
            if (claim.availableActions && claim.availableActions.includes(AvailableActions.EDIT)) {
                canActivate.next(true);
            } else {
                canActivate.next(false);
                this.router.navigate(['/', 'claim', claimNumber]);
                this.notFoundModal();
            }
        });

        return canActivate;
    }

    notFoundModal(): void {
        const confirmModalInstance: ConfirmModalComponent = this.modalService.open(ConfirmModalComponent, {
            centered: true
        }).componentInstance;
        confirmModalInstance.initModal({
            titleText: 'Error',
            subtitleText: `Page not found`,
            alertNotificationSeverity: AlertNotificationSeverity.ERROR,
            secondaryButtonText: 'Close'
        } as ConfirmModal);
    }
}
